"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindQueryDeltas = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useFindQueryDeltas(id) {
    const { data, isLoading, error, get } = (0, core_ui_1.useApiGet)(`queries/${id}/deltas`);
    return {
        queryDeltaList: data,
        isLoading,
        loadingError: error,
        getQueryDeltas: get
    };
}
exports.useFindQueryDeltas = useFindQueryDeltas;
//# sourceMappingURL=useFindQueryDeltas.js.map